import { render } from "./Physio.vue?vue&type=template&id=9d584722"
import script from "./Physio.vue?vue&type=script&lang=js"
export * from "./Physio.vue?vue&type=script&lang=js"

import "./Physio.vue?vue&type=style&index=0&id=9d584722&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__